'use es6';

import UIFlex from 'UIComponents/layout/UIFlex';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewReportErrorWrapper = ({
  title,
  children
}) => /*#__PURE__*/_jsx(View, {
  blockSize: "100%",
  children: /*#__PURE__*/_jsx(UIScrollContainer, {
    className: "m-top-3",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      align: "center",
      children: [title && /*#__PURE__*/_jsx(Text, {
        as: "h5",
        align: "center",
        marginBlockEnd: "400",
        children: title
      }), children]
    })
  })
});
export default ViewReportErrorWrapper;